import IImage from '@/interfaces/IImage';
import imageSourceHelpers from '@/helpers/images/imageSourceHelpers';
import { isIgnoredImageUrl } from '@/helpers/images/imageIgnoreList';

/**
 * Normalize image `src` fields, ignore specified patterns, and return reachable images.
 * Fallback logic is handled externally by the watcher.
 */
export function processImages(rawImages: IImage[], baseUrl: string): IImage[] {
    const results: IImage[] = [];

    for (const img of rawImages) {
        const fixedSrc = imageSourceHelpers.fixImageRelativeSrc(
            imageSourceHelpers.fixImageSrc(img),
            baseUrl
        ).src;

        if (!fixedSrc || isIgnoredImageUrl(fixedSrc)) {
            continue;
        }

        const finalImg = { ...img, src: fixedSrc };
        results.push(finalImg);
    }

    return results;
}
